export default "__VITE_ASSET__DFeRFYqO__"